<template id="Paiement">
	<div>
		<div class="plain_page">
			<div v-if="this.success" class="container">
				<h1>Félicitation {{infos.name}}!</h1>
				<h2>Le paiement de votre démarche  <strong>"{{infos.demarche}}"</strong> d'un montant total de {{infos.amount}}€ a bien été pris en compte.</h2>

				<p v-if="!portail">Vous allez recevoir un mail de confirmation sur l'adresse {{infos.mail}} afin de connaître les modalités d'envoi de votre dossier. </br></br>
				Pour suivre l'état d'avancement de votre dossier, rendez-vous sur <span @click="closeWin('suivi')" class="router">cette page.</span><br><br>
				Merci pour votre commande, et à bientôt</p>
			</div>
			<div v-if="this.fail" class="container">
				<h1 >Oops ! Le paiement a échoué !</h1>
			</div>
			<div v-if="this.unAuth" class="container">
				<h1 >Oops ! La requête n'a pas pu être authentifiée !</h1>
				<h2>Si vous avez correctement effectué votre paiement, pas d'inquiétude, nous reviendrons vers vous dans les plus brefs délais !</h2>
				<p>Si vous avez des questions, vous pouvez nous joindre par mail à l'adresse : contact@lesrelaiscartegrise.fr</p>
			</div>
			<div v-if="this.error" class="container">
				<h1 >Oops ! La page n'a pas été trouvée !</h1>
			</div>
			<button @click="closeWin('')">{{btn_txt}}</button>
		</div>
	</div>
</template>

<script>
const fb = require('../../firebaseConfig.js')
import firebase from 'firebase'
export default {
	name: 'Paiement',
	data () {
		return {
			success:false,
			fail:false,
			unAuth:false,
			error:false,
			portail:false,
			btn_txt:"",
			ref:"",
			sign:'',
			infos:{
				name:"",
				mail:"",
				amount:"",
				demarche:"",
				facture:"",
				naissance:""
			}
			}
	},
	methods:{
		closeWin(to){
			//console.log("closeWin");
			var message = "cleanVehicule";
			var init = "initIframe";

			if(to==''){
				//console.log("Close Win to=''");
				if(this.portail){
					//console.log("ClosWin Portail true");
					window.parent.postMessage(message,window.location.origin+"/paiement");
					window.top.location.href = "https://lesrelaiscartegrise.zohocreatorportal.eu/#Mes_d_marches";
				}else{
					//console.log("ClosWin Portail false");
					if(!this.fail){
						//console.log("ClosWin message sucess");
						window.parent.postMessage(message,window.location.origin+"/paiement");
					}
					//console.log("ClosWin init");
					window.parent.postMessage(init,window.location.origin+"/paiement");
				}
			}else if(to=='suivi'){
				window.parent.postMessage(message,window.location.origin+"/paiement");
				window.parent.postMessage(init,window.location.origin+"/paiement");
				window.top.location.href = "/go/suivi";
			}
		}
	},
	mounted(){
		this.btn_txt="Fermer";
		if(this.$route.query.Erreur=="00000"){
			//this.success=true;
			if(this.$route.query.Ref){
				this.ref=this.$route.query.Ref;
			}else{
				this.ref="empty"
			}
			this.sign=this.$route.query.sign;
			firebase.auth().signInAnonymously()
      		.then(() => {
				fb.db.collection('paiements').doc(this.ref).get().then(paiement => {
					var datas=paiement.data();
					if(datas.sign=this.sign){
						if(datas.source=="portail"){
							this.portail=true;
							this.btn_txt="Retourner sur le Portail Pro LRCG";
						}else if(datas.source=="site_web"){
							this.portail=false;
						}
						//console.log(datas)
						this.success=true;
						this.$store.state.vehicule.payment.statut="Réussi";
						this.infos.name=datas.nom;
						this.infos.mail=datas.email;
						this.infos.amount=datas.prixTotal,
						this.infos.demarche=datas.demarche.txt,
						//this.infos.facture=datas.facture,
						this.infos.naissance=datas.naissance
					}else{
						this.unAuth=true
						this.$store.state.vehicule.payment.statut="Réussi";
					}
				}).catch(error=>{
					setTimeout(()=>{
	   					fb.db.collection('paiements').doc(this.ref).get().then(paiement => {
	   					datas=paiement.data();
						if(datas.sign=this.sign){
							this.success=true;
							this.$store.state.vehicule.payment.statut="Réussi";
							this.infos.name=datas.nom;
							this.infos.mail=datas.email;
							this.infos.amount=datas.prixTotal,
							this.infos.demarche=datas.demarche.txt,
							//this.infos.facture=datas.facture,
							this.infos.naissance=datas.naissance
						}else{
							this.unAuth=true
							this.$store.state.vehicule.payment.statut="Réussi";
						}
	   					}).catch(error=>{
	   						this.unAuth=true
							this.$store.state.vehicule.payment.statut="Réussi";
							//console.log(error)
	   					});
					},3000);
					this.unAuth=true
					this.$store.state.vehicule.payment.statut="Réussi";
					//console.log(error)
				});
			});
		}else if(this.$route.query.Erreur){
			// if(document.referrer=="https://lesrelaiscartegrise.zohocreatorportal.eu/"||document.referrer=="https://creatorapp.zoho.eu/"){
			// 	this.portail=true;
			// }
			this.btn_txt="Réessayer"
			this.fail=true
		}else{
			this.error=true
		}
		// console.log(this.$route.query.type)
	}
}
</script>

<style scoped>
	.plain_page{
	background-color:#fbfbfb;
	position:fixed;
	top:0;
	left:0;
	height:100%;
	width:100%;
	z-index:100;
	display: flex;
	flex-direction: column;
	justify-content:center;
	align-items:center;
	}
	.container{
		text-align:center;
		width:500px;
		max-height:630px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	h1{
		text-align:center;
		font-weight:600;
		font-size:1.8em;
		width: 80%;
	}
	h2{
		font-weight:500;
		font-size: 1.6em;
		text-align:justify;
		width:80%;
	}
	button{
		margin-top: 20px;
	}
	p{
		text-align:justify;
		font-size: 1em;
		width:80%;
	}
	.router{
		text-decoration: underline;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/Go/Paiement.vue